export const formatCurrency = (val: any): string => {
  const num = parseFloat(val);
  if (isNaN(num)) return "$0.00";
  return "$" + num.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,");
};
